import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/Auth/Views/authorization.html';

@WithRender
@Component({
})
export default class Authorization extends Vue {
}
